import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';
import { shippingMessage } from './custom-shipping-calculation.js';

class ShippingProgress extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.section = this.closest('.shopify-section');
    this.price = Number(this.dataset.price);
    this.available = this.dataset.available === 'true';
    this.total = Number(this.dataset.total);
    this.currency = this.dataset.currency;
    this.sequence = 0;
    this.section?.addEventListener(ThemeEvents.quantitySelectorUpdate, () => this.render(), { signal });
    this.section?.addEventListener('change', () => this.render(), { signal });
    this.section?.addEventListener(StandardEvents.productSelect, async (event) => {
      if (event.target?.closest('product-card')) return;
      try {
        const result = await event.promise;
        if (signal.aborted) return;
        const next = result?.detail?.html?.querySelector('custom-shipping-progress');
        if (next) {
          this.price = Number(next.dataset.price);
          this.available = next.dataset.available === 'true';
          this.render();
        }
      } catch { /* Keep the last confirmed selection when a request is cancelled. */ }
    }, { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
      try { await event.promise; } catch { return; }
      if (!signal.aborted) this.refresh();
    }, { signal });
    window.addEventListener('pageshow', () => this.refresh(), { signal });
    this.render();
    this.refresh();
  }
  disconnectedCallback() { this.controller?.abort(); }
  async refresh() {
    const sequence = ++this.sequence;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal:this.controller.signal, headers:{Accept:'application/json'} });
      if (!response.ok) return;
      const cart = await response.json();
      if (sequence !== this.sequence || !this.isConnected) return;
      this.total = cart.total_price;
      this.currency = cart.currency;
      this.render();
    } catch { /* The Liquid-rendered cart amount remains usable offline. */ }
  }
  render() {
    const message = this.querySelector('.custom-shipping-progress__message');
    const meter = this.querySelector('progress');
    if (this.currency !== 'USD') {
      meter.hidden = true;
      message.textContent = 'Free shipping on eligible orders of US $99.99 or more. See details for eligibility.';
      return;
    }
    const input = this.section?.querySelector('product-form-component input[name="quantity"]');
    const quantity = Math.max(1, Number(input?.value) || 1);
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:'USD' }).format(value / 100);
    message.textContent = shippingMessage(this.total, this.price, quantity, this.available, money);
    meter.hidden = false;
    meter.value = Math.min(9999, Math.max(0, this.total));
    meter.setAttribute('aria-valuetext', `${money(this.total)} of ${money(9999)}`);
  }
}
if (!customElements.get('custom-shipping-progress')) customElements.define('custom-shipping-progress', ShippingProgress);
